const MAP_STYLE = [
  { elementType: "geometry", stylers: [{ color: "#f4f1ec" }] },
  { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#7a716a" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#f8f6f2" }] },
  {
    featureType: "administrative.land_parcel",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text",
    stylers: [{ visibility: "off" }],
  },
  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#dfe6d2" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
  {
    featureType: "road.arterial",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  },
  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#f6e7cf" }] },
  { featureType: "transit", stylers: [{ visibility: "off" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#c8d9e4" }] },
];

export default MAP_STYLE;
